import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import api from '../components/setupAxios';
import API_URL from "../config";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import "../styles/style.css";
import { Box,Button, ButtonGroup, Typography } from '@mui/material';

const AssistantDashboard = ({onStatusChange}) => {
    const [labs, setLabs] = useState([]);
    const [schedule, setSchedule] = useState([]);
    const [sessions, setSessions] = useState({ scheduled: [], active: [], ended: [] });
    const navigate = useNavigate();

    const adjustDateToDayOfWeek = (timeString, targetDay, referenceTimeString = null) => {
      const time = new Date(timeString);
      const now = new Date();

      const diff = (targetDay - now.getDay() + 7) % 7;
      let eventDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + diff,
        time.getHours(),
        time.getMinutes(),
        time.getSeconds()
      );

      if (referenceTimeString) {
        const refTime = new Date(referenceTimeString);
        const refMinutes = refTime.getHours() * 60 + refTime.getMinutes();
        const eventMinutes = eventDate.getHours() * 60 + eventDate.getMinutes();
        if (eventMinutes <= refMinutes) {
          eventDate.setDate(eventDate.getDate() + 1);
        }
      }
      return eventDate.toISOString();
    };
    

    useEffect(() => {

        fetchLabs();  
        fetch(`${API_URL}/lab-schedules`)
            .then(res => res.json())
            .then(data => setSchedule(data))
            .catch(err => console.error(err));

        fetch(`${API_URL}/lab-sessions`)
            .then(res => res.json())
            .then(data => {
                setSessions({
                    scheduled: data.filter(session => session.status === 'scheduled'),
                    active: data.filter(session => session.status === 'active'),
                    ended: data.filter(session => session.status === 'ended')
                });
            })
            .catch(err => console.error(err));
      }, []);
    
    const fetchLabs = async () => {
        try {
          const response = await api.get("/lab");
          setLabs(response.data);
        } catch (error) {
          console.error("Error fetching labs:", error);
        }
      };
    
      const fetchSessions = async () => {
        try {
          const response = await api.get("/lab-sessions");
          setSessions(response.data);
        } catch (error) {
          console.error("Error fetching sessions:", error);
        }
      };

    const handleSessionClick = (sessionId) => {
        navigate(`/assistant-session/${sessionId}`); 
    };

    const handleHistoryClick = (sessionId) => {
        navigate(`/session-history`); 
    };

    const mergedSchedules = schedule.reduce((acc, curr) => {
        const key = `${adjustDateToDayOfWeek(curr.startTime, curr.dayOfWeek)}-${adjustDateToDayOfWeek(curr.endTime, curr.dayOfWeek)}`;
        
        if (!acc[key]) {
            acc[key] = { 
                locations: new Set(), 
                startTime: curr.startTime,
                 endTime: curr.endTime, 
                 dayOfWeek: curr.dayOfWeek ,
                 isActive: curr.isActive 
                };
        }
    
        acc[key].locations.add(curr.lab?.location || "Unknown Location");
        return acc;
    }, {});
    
    const formattedEvents = Object.values(mergedSchedules)
    .filter(event => event.isActive)
    .map(event => ({
        title: Array.from(event.locations).join(", "), 
        start: adjustDateToDayOfWeek(event.startTime, event.dayOfWeek),
        end: adjustDateToDayOfWeek(event.endTime, event.dayOfWeek)
    }));
    

    const generateSessions = async () => {
        try {
        // const response = await api.get("/lab-sessions");
        // const activeSessions = response.data.filter(session => session.status === "active");

        // if (activeSessions.length > 0) {
        //     alert("Now is not the time for refreshing, there are still ongoing sessions.");
        //     return;
        // }

        // const hasReason = window.confirm("Is there a reason to refresh? (For example: temporary session cancellation/addition, device failure/repair, etc.)");
        // if (!hasReason) {
        //     alert("Do not refresh without reasons.");
        //     return;
        // }

        // const backupConfirmed = window.confirm("Please confirm if all data has been backed up, such as downloading all logs.");
        // if (!backupConfirmed) {
        //     alert("Please backup the data before performing the refresh operation.");
        //     return;
        // }

        // const finalConfirmation = window.confirm("This operation will delete all sessions of this week and regenerate them. \nThis will clear the history, are you sure you want to continue?");
        // if (!finalConfirmation) {
        //     alert("The operation has been canceled.");
        //     return;
        // }
          await api.post("/lab-schedules/generate-session", {}, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
          });
          fetchSessions(); 
          alert("Generation successed.")
          window.location.reload();
        } catch (error) {
          alert("Error generating weekly sessions:", error);
        }
      };

      const [selectedStatus, setSelectedStatus] = useState('scheduled');
        const handleStatusClick = (status) => {
          setSelectedStatus(status);
          if (onStatusChange) {
            onStatusChange(status);
          }
        };

      return (
        <div className="dashboard-container">
          {/* Fullcalendar */}
          <div className="calendar-container">
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin]}
              initialView="timeGridWeek"
              slotMinTime="08:00:00"
              slotMaxTime="23:00:00"
              events={formattedEvents}
              allDaySlot={false}
            />
          </div>
      
          {/* Session  */}
          <div className="session-container">
            <Typography variant="h4" mb={2} >
            Today's Sessions
            </Typography>
      
            {/* The full width button group is used to switch states */}
            <div style={{ marginBottom: '1rem' }}>
              <ButtonGroup variant="contained" fullWidth aria-label="session status button group">
                <Button
                  color={selectedStatus === 'scheduled' ? 'primary' : 'inherit'}
                  onClick={() => handleStatusClick('scheduled')}
                >
                  Scheduled
                </Button>
                <Button
                  color={selectedStatus === 'active' ? 'primary' : 'inherit'}
                  onClick={() => handleStatusClick('active')}
                >
                  Active
                </Button>
                <Button
                  color={selectedStatus === 'ended' ? 'primary' : 'inherit'}
                  onClick={() => handleStatusClick('ended')}
                >
                  Ended
                </Button>
              </ButtonGroup>
            </div>
      
            {/* Display session cards based on the current selected status */}
            <div>
                {(() => {
                  const filteredSessions = sessions[selectedStatus]?.filter(session => {
                    const sessionDate = new Date(session.scheduledStart);
                    const today = new Date();
                    return sessionDate.toDateString() === today.toDateString();
                  }) || [];

                if (filteredSessions.length === 0) {
                    return (
                      <Typography
                        variant="body1"
                        align="center"
                        style={{ fontStyle: 'italic', color: 'grey', margin: '3rem 0' }}
                      >
                        There is currently no {selectedStatus} session avaiable.
                      </Typography>
                    );
                  }

                return filteredSessions.map(session => {
                    const adjustedStart = adjustDateToDayOfWeek(session.scheduledStart, session.dayOfWeek);
                    const adjustedEnd = adjustDateToDayOfWeek(session.scheduledEnd, session.dayOfWeek);
                    return (
                    <div className="card1" key={session._id} onClick={() => handleSessionClick(session._id)}>
                        <div className="card-left">
                        <div className="lab-code">
                            {session.lab?.location || 'Unknown Location'}
                        </div>
                        </div>
                        <div className="card-right">
                        <h3>{session.lab?.name || 'Unknown Lab'}</h3>
                        <p>
                            {new Date(adjustedStart).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false
                            })}
                            -
                            {new Date(adjustedEnd).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false
                            })}
                        </p>
                        <p>
                            Occupancy: {session.occupancy}/{session.lab.capacity}
                        </p>
                        <p>
                            Available Computers: {session.availableSeats}
                        </p>
                        </div>
                    </div>
                    );
                });
                })()}
            </div>
      
            {/* Bottom operation button */}
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <Button variant="contained" sx={{ flex: 1 }} onClick={generateSessions}>
                Refresh This Week's Sessions
              </Button>
              <Button variant="contained" sx={{ flex: 1 }} onClick={handleHistoryClick}>
                View Historical Sessions
              </Button>
            </Box>

          </div>
        </div>
      );      
};

export default AssistantDashboard;
